export default __webpack_public_path__ + "static/media/header-arrow-down.dc3c61bf.svg";